import { createSlice } from "@reduxjs/toolkit";

import SupportCaseModel from "models/SupportCaseModel";
import { initialResultsDtoModel, ResultsDtoModel } from 'models/ResultsDtoModel';

import { getSupportCases } from "services/case.service";

import { RootState } from "store/store";


interface CaseState {
    casesDto: ResultsDtoModel<SupportCaseModel>;
    loading: boolean;
    error?: string | null;
}

const initialState: CaseState = {
    casesDto: initialResultsDtoModel,
    loading: false,
    error: null
}

const demoCase: SupportCaseModel[] = [
    {
        "caseId": 7167745,
        "caseNumber": "BCDCASE008786",
        "title": "ST: D26966613 - Unable to Boot into Windows",
        "incidentDate": new Date(),
        "note": "Latest Note",
        "status": "In Progress",
        "serialNumber": "D2695613",
        "assignedTo": "M. Roe",
        "lastCustomerMessage": new Date()
    },
    {
        "caseId": 7161271,
        "caseNumber": "BCDCASE008780",
        "title": "ST: 8PVTN23Z3 - Windows log in credentials lost -  Warranty Expires 21 FEB 2029",
        "incidentDate": new Date(),
        "note": "Latest Note",
        "status": "In Progress",
        "serialNumber": "8PVT23NZ3",
        "assignedTo": "T. Rex",
        "lastCustomerMessage": new Date()
    },
    {
        "caseId": 7163266,
        "caseNumber": "BCDCASE008775",
        "title": "ST: FGD6BGFF3 - ISO Requested",
        "incidentDate": new Date(),
        "note": "Latest Note",
        "status": "Closed",
        "serialNumber": "FGD6BGFF3",
        "assignedTo": "M. Rex",
        "lastCustomerMessage": new Date()
    }
]

export const casesSlice = createSlice({
    name: "cases",
    initialState,
    reducers: {
        clearCases: (state) => {
            state.casesDto = initialResultsDtoModel;
        },
        setDemoCases: (state) => {
            state.casesDto.items = demoCase
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getSupportCases.fulfilled, (state, action) => {
                state.casesDto = action.payload;
                state.loading = false;
                state.error = null;
            })
            .addCase(getSupportCases.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getSupportCases.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message || 'Failed to load support cases';
            })
    }
});

export const selectCasesDto = (state: RootState) => state.cases.casesDto;
export const casesReducer = casesSlice.reducer;
export const { clearCases, setDemoCases } = casesSlice.actions;